import React from "react";
const Search = (props) => {
   
  return (
    <React.Fragment>
<div className="breadcrumb-area-listing floriculture mt-140">
  <div className="container">
    <div className="breadcrumb-content">
      <h2>Floriculture</h2>
      <ul>
        <li><a title="Home" href="index.html">home</a></li>
        <li> Floriculture </li>
      </ul>
    </div>
  </div>
</div>
    </React.Fragment>
  );
};

export default Search;
